export default __webpack_public_path__ + "static/Graphik-Semibold-Cy-Web-79c9f39c6f96c782bc2b2db1e3f19146.woff";